import { render, staticRenderFns } from "./PeriodicalDoc.vue?vue&type=template&id=71e3f188&scoped=true"
import script from "./PeriodicalDoc.vue?vue&type=script&lang=js"
export * from "./PeriodicalDoc.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalDoc.vue?vue&type=style&index=0&id=71e3f188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e3f188",
  null
  
)

export default component.exports